import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { BuilderContext, useDrawer } from "react-flow-builder";
import {
  Row,
  Col,
  Input,
  Select,
  Tooltip,
  Button,
  Slider,
  InputNumber,
  Form,
} from "antd";
import { DeleteTwoTone, PlusCircleOutlined } from "@ant-design/icons";
import { notify } from "../../../../../../../components/Snack";
import { store } from "../../../../../../../redux";
import { setDraft } from "../../../../../../../redux/actions/skill";
const { TextArea } = Input;
const { Option } = Select;

const selectBefore = (
  <Select defaultValue="user">
    <Option value="user">User</Option>
    {/* <Option value="assistant">Assistant</Option> */}
  </Select>
);

const ChatGptConfig = (props) => {
  const [form] = Form.useForm();

  const dispatch = useDispatch();
  const [nodeData, setNodeData] = useState(null);

  const skill = useSelector((state) => state.skillReducer.trainDraft);
  const [temperature, setTemperature] = useState(1);
  const [modelName, setModelName] = useState("");
  const [userContent, setUserContent] = useState("");
  const [systemContent, setSystemContent] = useState("");
  const [outputVariable, setOutputVariable] = useState("");
  const onChange = (newValue) => {
    setTemperature(newValue);
  };
  useEffect(() => {
    if(props?.data) {
    setNodeData(props?.data);
    setTemperature(props?.data?.temperature);
    setModelName(props?.data?.model);
    setUserContent(props?.data?.messages[1]?.content);
    setSystemContent(props?.data?.messages[0]?.content);
    setOutputVariable(props?.data?.variable);
    return () => {};
    }
  }, [props?.data]);

  const onChangeGptModal = (value) => {
    setModelName(value);
  };
  const onChangeUserContent = (e) => {
    setUserContent(e.target.value);
  };
  const onChangeSystemContent = (e) => {
    setSystemContent(e.target.value);
  };

  const onChangeVarName = (e) => {
    setOutputVariable(e.target.value);
  };

  const findAndUpdate = (arr, id, payload) => {
    let found = arr.findIndex((i) => i.id == id);
    if (found > -1) {
      arr[found] = { ...arr[found], ...payload };
    } else {
      arr.forEach((element) => {
        if (
          [
            "branch",
            "condition",
            "loop",
            "loop-nodes",
            "try",
            "try-catch-node",
            "review",
            "review-node",
          ].includes(element.type)
        ) {
          findAndUpdate(element.children, id, payload);
        }
      });
    }
    return arr;
  };

  const handleSubmit = async () => {
    try {
      if (
        modelName == "" ||
        systemContent == "" ||
        userContent == "" ||
        outputVariable == ""
      ) {
        dispatch(notify("error", "All fields are mandatory"));
      } else {
        let msgObj = [
          {
            role: "system",
            content: systemContent,
          },
          {
            role: "user",
            content: userContent,
          },
        ];
        nodeData["messages"] = msgObj;
        nodeData["model"] = modelName;
        nodeData["variable"] = outputVariable;
        nodeData["temperature"] = temperature;
        setNodeData(nodeData);
        let newActions = findAndUpdate(
          skill?.RAW_DATA?.actions,
          props?.data?.id,
          nodeData
        );

        store.dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill?.RAW_DATA, actions: newActions },
          })
        );
        props?.updateConfig(nodeData, props?.data?.id);
        props?.closeDrawer();

        setNodeData(null);
        setTemperature(1);
        setModelName("");
        setUserContent("");
        setSystemContent("");
        setOutputVariable("");
      }
    } catch (err) {
      console.log("form error", err);
    }
  };
  return (
    <Row className="chatgpt-row">
      <Col span={18}>
        <div className="textarea-block">
          <h4>System</h4>
          <TextArea
            placeholder="You are a helpful Assistant"
            rows={4}
            onChange={onChangeSystemContent}
            defaultValue={props?.data?.messages[0]?.content}
          />
        </div>
        <hr />
        <div className="chg-message">
          {/* <Input addonBefore={selectBefore} addonAfter={<Tooltip title="Delete"><DeleteTwoTone twoToneColor="#eb2f96" /></Tooltip>}  placeholder="Enter your message here" />*/}
          <div className="textarea-block">
            <h4>User</h4>
            <TextArea
              rows={6}
              placeholder="Enter your message here"
              onChange={onChangeUserContent}
              defaultValue={props?.data?.messages[1]?.content}
            ></TextArea>
          </div>
          <br />
          <Button type="primary" onClick={handleSubmit}>
            Save
          </Button>
        </div>
      </Col>
      <Col span={6} className="config-items-outer">
        <div className="config-items">
          <div className="cnf-item">
            <label>Model</label>
            <Select
              showSearch
              style={{
                width: "100%",
              }}
              placeholder="Search to Select"
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label ?? "").includes(input)
              }
              filterSort={(optionA, optionB) =>
                (optionA?.label ?? "")
                  .toLowerCase()
                  .localeCompare((optionB?.label ?? "").toLowerCase())
              }
              options={[
                {
                  value: "gpt-3.5-turbo",
                  label: "gpt-3.5-turbo",
                },
                {
                  value: "gpt-3.5-turbo-16k-0613",
                  label: "gpt-3.5-turbo-16k-0613",
                },
                {
                  value: "gpt-3.5-turbo-16k",
                  label: "gpt-3.5-turbo-16k",
                },
                {
                  value: "gpt-3.5-turbo-1106",
                  label: "gpt-3.5-turbo-1106",
                },
                {
                  value: "gpt-3.5-turbo-0613",
                  label: "gpt-3.5-turbo-0613",
                },
                {
                  value: "gpt-3.5-turbo-03031",
                  label: "gpt-3.5-turbo-03031",
                },
              ]}
              onChange={onChangeGptModal}
              defaultValue={props?.data?.model}
            />
          </div>
          <div className="cnf-item">
            <label>Temperature</label>
            <div className="cnf-slider">
              <Slider
                min={0}
                max={1}
                onChange={onChange}
                value={temperature}
                step={0.1}
              />
              <InputNumber
                min={0}
                max={1}
                style={{
                  margin: "0 16px",
                }}
                step={0.1}
                value={temperature}
                onChange={onChange}
              />
            </div>
          </div>
          <div className="cnf-item">
            <label>Output Variable</label>
            <div className="cnf-slider">
              <Input
                defaultValue={props?.data?.variable}
                onChange={onChangeVarName}
              />
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default ChatGptConfig;
